var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"display-1 font-weight-bold mx-1 mb-3"},[_vm._v(" Magnets ")]),_c('v-img',{attrs:{"src":require("../../../assets/Background-Magnets-2366x901.jpeg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }